  <div
    class="avatar-box"
    (keydown.enter)="click()"
    (keydown.space)="click()"
    (click)="click()"
    [attr.tabindex]="editable ? '0' : ''"
    [attr.role]="editable ? 'button' : ''"
    aria-label="Avatar"
    [attr.aria-description]="editable ? 'Activate to upload a new avatar' : ''"
    [class.editable]="editable"
    [class.disabled]="disabled"
  >
    @if (src) {
      <img class="avatar" alt="" [src]="src">
    }
    @else {
      <img class="avatar" alt="" src="/assets/image/graphic/profile-good.svg">
    }
    @if (editable) {
      <div class="edit-avatar-button">
        <mat-icon>edit</mat-icon>
      </div>
    }
    <input
      #avatarInput
      type="file"
      [accept]="acceptStr"
      [disabled]="disabled"
      (change)="onInputChange($event)"
    >
  </div>
